// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper-pagination{bottom:5px;display:flex;gap:10px;justify-content:center;position:absolute;width:100%}.swiper-pagination-bullet{background-color:#e3e3e3!important;border-radius:0!important;height:5.66px!important;opacity:1!important;transform:rotate(45deg);width:5.66px!important}.swiper-pagination-bullet-active{background-color:#000!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
